import { useTranslation } from 'react-i18next';
import { PreviewUserDataFragment } from '../../../../api';
import OutlinedMultiSelectField from '../../../../components/fields/OutlinedMultiSelectField';

type DealerSelectionProps = {
    dealers: PreviewUserDataFragment[];
    onSelectionChange?: (selectedIds: string[]) => void;
};

const DealerSelection = ({ dealers, onSelectionChange }: DealerSelectionProps) => {
    const { t } = useTranslation(['purchaseTransactionsPage', 'common']);

    return (
        <OutlinedMultiSelectField<PreviewUserDataFragment>
            color="secondary"
            getOptionLabel={dealer => dealer.fullName}
            label={t('purchaseTransactionsPage:quotation.inviteQuote.dealerIndividual')}
            name="dealerIds"
            noOptionsText={t('common:noDealers')}
            onSelectionChange={onSelectionChange}
            options={dealers}
            placeholder={t('common:searchDealers')}
            renderOption={dealer => dealer.fullName}
        />
    );
};

export default DealerSelection;
